export const ACCOUNT_TYPES = {
  rfb: 'rfb',
  account: 'account',
  invoice: 'invoice',
  card: 'card',
};
